var map = {
	"./aia.svg": 1374,
	"./ant.svg": 1375,
	"./aus.svg": 1376,
	"./bah.svg": 1377,
	"./ban.svg": 1378,
	"./bar.svg": 1379,
	"./ber.svg": 1380,
	"./biz.svg": 1381,
	"./bot.svg": 1382,
	"./bru.svg": 1383,
	"./can.svg": 1384,
	"./cay.svg": 1385,
	"./cmr.svg": 1386,
	"./cok.svg": 1387,
	"./cyp.svg": 1388,
	"./dma.svg": 1389,
	"./eng.svg": 1390,
	"./fij.svg": 1391,
	"./flk.svg": 1392,
	"./gab.svg": 1393,
	"./gam.svg": 1394,
	"./ggy.svg": 1395,
	"./gha.svg": 1396,
	"./gib.svg": 1397,
	"./grn.svg": 1398,
	"./guy.svg": 1399,
	"./ind.svg": 1400,
	"./iom.svg": 1401,
	"./ivb.svg": 1402,
	"./jam.svg": 1403,
	"./jey.svg": 1404,
	"./ken.svg": 1405,
	"./kir.svg": 1406,
	"./lca.svg": 1407,
	"./les.svg": 1408,
	"./manifest.json": 769,
	"./mas.svg": 1409,
	"./maw.svg": 1410,
	"./mdv.svg": 1411,
	"./mlt.svg": 1412,
	"./moz.svg": 1413,
	"./mri.svg": 1414,
	"./msr.svg": 1415,
	"./nam.svg": 1416,
	"./nfk.svg": 1417,
	"./ngr.svg": 1418,
	"./nir.svg": 1419,
	"./niu.svg": 1420,
	"./nru.svg": 1421,
	"./nzl.svg": 1422,
	"./pak.svg": 1423,
	"./png.svg": 1424,
	"./rsa.svg": 1425,
	"./rwa.svg": 1426,
	"./sam.svg": 1427,
	"./sco.svg": 1428,
	"./sey.svg": 1429,
	"./sgp.svg": 1430,
	"./shn.svg": 1431,
	"./skn.svg": 1432,
	"./sle.svg": 1433,
	"./sol.svg": 1434,
	"./sri.svg": 1435,
	"./svg-country.svg": 1436,
	"./swz.svg": 1437,
	"./tan.svg": 1438,
	"./tca.svg": 1439,
	"./tga.svg": 1440,
	"./tog.svg": 1441,
	"./tto.svg": 1442,
	"./tuv.svg": 1443,
	"./uga.svg": 1444,
	"./van.svg": 1445,
	"./wal.svg": 1446,
	"./zam.svg": 1447
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1373;